import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { CiTextAlignJustify } from 'react-icons/ci';
import { LuLayoutGrid } from 'react-icons/lu';
import { GrPowerReset } from 'react-icons/gr';
import UserList from '../components/User/UserList';
import UserGrid from '../components/User/UserGrid';
import useUserManagement from '../hooks/UserManagement/useUserManagement';
import { resetFilter, setIsVerified, setStatus } from '../store/slice/filterSlice';
import { ImFilter } from 'react-icons/im';

const UserManagementPage = () => {
  const [activePage, setActivePage] = useState('list');
  const dispatch = useDispatch();
  const {
    activePopoverId,
    paginatedPeople,
    deleteUser,
    togglePopover,
    getCountryAbbreviation,
    status,
    isVerified,
  } = useUserManagement();

  return (
    <div className="sm:ml-64 w-[80%] min-h-[calc(100vh-63px)] bg-[#F4F5F6]">
      <div className="px-4">
        <div className="flex items-center justify-between pt-8">
          <div className="flex items-center justify-around rounded-lg bg-[#FFFFFF] w-[100px] h-[42px]">
            <button
              className={`p-2 ${activePage === 'list' ? 'bg-[#F1F1F1]' : ''}`}
              onClick={() => setActivePage('list')}
              aria-label="List view">
              <CiTextAlignJustify />
            </button>
            <button
              className={`p-2 ${activePage === 'grid' ? 'bg-[#F1F1F1]' : ''}`}
              onClick={() => setActivePage('grid')}
              aria-label="Grid view">
              <LuLayoutGrid />
            </button>
          </div>
          <div className="inline-flex justify-evenly items-center w-[450px]  h-[42px] bg-[#eeeded] border rounded-lg">
            <div className="flex justify-center items-start text-[#000000] border-r border-gray-300 pr-2.5">
              <ImFilter className="w-4 h-4 fill-gray-900" />
            </div>
            <div className="flex items-center h-full px-2 border-r border-gray-300">
              <p className="text-xs font-semibold text-[#202224]">Filter by</p>
            </div>
            <div className="flex items-center h-full px-2 border-r border-gray-300">
              <select
                className="w-full bg-transparent text-xs font-semibold text-[#ADAEB0] focus:outline-none"
                value={status || ''}
                onChange={e => dispatch(setStatus(e.target.value))}>
                <option value="" disabled>
                  User Status
                </option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div>
            <div className="flex items-center h-full px-2 border-r border-gray-300">
              <select
                className="w-full bg-transparent text-xs font-semibold text-[#ADAEB0] focus:outline-none"
                value={isVerified || ''}
                onChange={e => dispatch(setIsVerified(e.target.value))}>
                <option value="" disabled>
                  Verification Status
                </option>
                <option value="true">Verified</option>
                <option value="false">Not Verified</option>
              </select>
            </div>
            <button
              className="flex items-center h-full"
              onClick={() => dispatch(resetFilter())}
              aria-label="Reset filter">
              <p className="text-xs font-semibold inline-flex text-[#EA0234]">
                <span className="mx-1 my-auto">
                  <GrPowerReset size={12} />
                </span>{' '}
                Reset
              </p>
            </button>
          </div>
        </div>
        {activePage === 'list' ? (
          <UserList
            users={paginatedPeople}
            activePopoverId={activePopoverId}
            togglePopover={togglePopover}
            deleteUser={deleteUser}
            getCountryAbbreviation={getCountryAbbreviation}
          />
        ) : (
          <UserGrid
            users={paginatedPeople}
            activePopoverId={activePopoverId}
            togglePopover={togglePopover}
            deleteUser={deleteUser}
            getCountryAbbreviation={getCountryAbbreviation}
          />
        )}
      </div>
    </div>
  );
};

export default UserManagementPage;
